export const loadLanguage = () => {
  try {
    const language = localStorage.getItem('language');
    if (language === null) {
      return undefined;
    }
    return language;
  } catch (e) {
    return undefined;
  }
};

export const saveLanguage = (language) => {
  try {
    localStorage.setItem('language', language);
  } catch (e) {}
};

export const loadTheme = () => {
  try {
    const theme = localStorage.getItem('theme');
    if (theme === 'dark') {
      return 'dark';
    }
    // if (theme === 'light') {
    //   return 'light';
    // }
    return 'light';
    // return null;
  } catch (e) {
    return 'light';
    // return null;
  }
};

export const saveTheme = (theme) => {
  try {
    if (theme === 'dark') {
      localStorage.setItem('theme', 'dark');
    } else {
      localStorage.setItem('theme', 'light');
    }
  } catch (e) {}
};

export const loadUser = () => {
  try {
    const user = sessionStorage.getItem('user');
    if (user) return JSON.parse(user);
    return user;
  } catch (e) {
    return null;
  }
};

export const saveUser = (user) => {
  try {
    if (user) {
      sessionStorage.setItem('user', JSON.stringify(user));
    }
  } catch (e) {}
};

export const deleteUser = () => {
  try {
    sessionStorage.removeItem('user');
  } catch (e) {}
};

export const loadFCStation = () => {
  try {
    const fc_station = localStorage.getItem('fc_station');
    if (fc_station === null) {
      return undefined;
    }
    return fc_station;
  } catch (e) {
    return undefined;
  }
};

export const loadData = (data) => {
  if (!data) {
    return undefined;
  }
  try {
    const value = localStorage.getItem(data);
    if (value === null) {
      return undefined;
    }
    return value;
  } catch (e) {
    return undefined;
  }
};

export const saveData = (data, value) => {
  if (data && data.trim() && value && value.trim()) {
    try {
      localStorage.setItem(data, value);
    } catch (e) {}
  }
};

export const removeData = (data) => {
  if (data && data.trim()) {
    try {
      localStorage.removeItem(data);
    } catch (e) {}
  }
};
